<template>
  <div class="print-break-after">
    <!-- 
      Div a scomparsa per mostrare un'immagine utilizzando tutta la finestra popup
    -->
    <div v-if="tabToShow === 'pic'" class="wg-row pic-viewer">
      <picture-viewer :picToShow="picToShow"></picture-viewer>
      <img
        :src="$anm22.icons.getWorldIcon('deleteBlack')"
        class="close-pic"
        @click="closePic"
      />
    </div>
    <!-- 
      Div principale
    -->
    <div v-show="tabToShow === 'default'" class="wg-row">
      <!-- GRAPHICS -->
      <template v-if="mode === 'edit' || mode === 'prod'">
        <div class="wg-row">
          <div class="com-anm22-app-text-xl">
            {{ $anm22.strLang(lang, "Graphics", "Grafica") }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-row">
          <template v-if="graphicImages">
            <div
              v-for="(img, index) in graphicImages.filter((i) => i)"
              :key="'img-' + index"
              style="position:relative;height:100px;width:100px;margin:5px;cursor:pointer;"
            >
              <img
                style="height:100%;width:100%;"
                :src="$anm22.getImagePath(img)"
                @click="showPic(img)"
              />
            </div>
          </template>
        </div>
        <div class="vertical-height-div" style="height:20px;"></div>
      </template>
      <!-- COLORS -->
      <div class="wg-row input-row" style="height:36px;">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Colors", "Colori") }}
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">1</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color1"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color1-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color1 == '' ? 'Nessun Colore' : getColorName(color1)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color1qnt"
              placeholder="qnt"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">2</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color2"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color2-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color2 == '' ? 'Nessun Colore' : getColorName(color2)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color2qnt"
              placeholder="qnt"
            />
          </div>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">3</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color3"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color3-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color3 == '' ? 'Nessun Colore' : getColorName(color3)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color3qnt"
              placeholder="qnt"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">4</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color4"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color4-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color4 == '' ? 'Nessun Colore' : getColorName(color4)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color4qnt"
              placeholder="qnt"
            />
          </div>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">5</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color5"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color5-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color5 == '' ? 'Nessun Colore' : getColorName(color5)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color5qnt"
              placeholder="qnt"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">6</div>
            <select
              v-if="mode == 'edit'"
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-select"
              v-model="color6"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color6-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color6 == '' ? 'Nessun Colore' : getColorName(color6)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color6qnt"
              placeholder="qnt"
            />
          </div>
        </div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">7</div>
            <select
              v-if="mode == 'edit'"
              class="input-elem com-anm22-app-select"
              v-model="color7"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color7-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color7 == '' ? 'Nessun Colore' : getColorName(color7)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color7qnt"
              placeholder="qnt"
            />
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">8</div>
            <select
              v-if="mode == 'edit'"
              :disabled="mode === 'view'"
              class="input-elem com-anm22-app-select"
              v-model="color8"
            >
              <option value>Nessun Colore</option>
              <option
                v-for="(color, index) in selectColorList()"
                :key="'color8-' + index"
                :value="color.idWarehouseProduct"
                >{{ color.name }}</option
              >
            </select>
            <input
              disabled
              type="text"
              class="input-elem com-anm22-app-input-text"
              v-else
              :value="color8 == '' ? 'Nessun Colore' : getColorName(color8)"
            />
            <input
              v-if="mode == 'edit' || mode == 'prod'"
              type="text"
              class="input-qnt-elem com-anm22-app-input-text"
              v-model="color8qnt"
              placeholder="qnt"
            />
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <!-- NOTE -->
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Notes", "Note") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <textarea
            :class="[
              'input-elem com-anm22-app-textarea',
              mode === 'view' ? 'stamp' : '',
            ]"
            style="height:100px;width:100%;max-width:unset;"
            v-model.lazy="formData.notes"
          ></textarea>
        </div>
      </div>
      <div
        class="wg-row input-row"
        v-if="
          mainProjectDocs &&
            mainProjectDocs.cutting &&
            mainProjectDocs.cutting.notes
        "
      >
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{
              $anm22.strLang(
                lang,
                "Main project notes",
                "Note progetto originale"
              )
            }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ mainProjectDocs.cutting.notes }}
          </div>
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
      </div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ $anm22.strLang(lang, "Last edit", "Ultima modifica") }}
          </div>
        </div>
        <div class="vertical-height-div wg-sm-none" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="com-anm22-app-text-m">
            {{ lastEditDate + " " + lastEditUser }}
          </div>
        </div>
      </div>
      <div class="vertical-height-div" style="height:20px;"></div>
      <div v-if="mode === 'edit'" class="wg-row">
        <input
          type="button"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="saveForm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PictureViewer from "./PictureViewer.vue";

export default {
  props: {
    projectId: [Number, String],
    docs: Object,
    mainProjectDocs: {
      type: Object | null,
      default: null,
    },
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      formData: {},
      graphicsData: {},
      tabToShow: "default",
      picToShow: null,
      colorList: [
        { idWarehouseProduct: 134, name: "Bovina Nero Asfalto 09" },
        { idWarehouseProduct: 135, name: "Bovina Grigio Grafite 10" },
        { idWarehouseProduct: 136, name: "Bovina Silver Alluminio 11" },
        { idWarehouseProduct: 137, name: "Bovina Cromato 87" },
        { idWarehouseProduct: 138, name: "Bovina Bianco Ghiaccio 04" },
        { idWarehouseProduct: 139, name: "Bovina Oro 17" },
        { idWarehouseProduct: 140, name: "Bovina Verde Bandiera 22" },
        { idWarehouseProduct: 141, name: "Bovina Verde Fluorescente 24" },
        { idWarehouseProduct: 142, name: "Bovina Azzurro Jerez 01" },
        { idWarehouseProduct: 143, name: "Bovina Blu Metallizzato 02" },
        { idWarehouseProduct: 144, name: "Bovina Blu Scozia 03" },
        { idWarehouseProduct: 145, name: "Bovina Giallo Fluorescente 05" },
        { idWarehouseProduct: 146, name: "Bovina Giallo Corse 14" },
        { idWarehouseProduct: 147, name: "Bovina Arancione Fluorescente 06" },
        { idWarehouseProduct: 148, name: "Bovina Rosso Fluorescente 17" },
        { idWarehouseProduct: 149, name: "Canguro Nero Asfalto 50" },
        { idWarehouseProduct: 150, name: "Canguro Grigio Grafite 51" },
        { idWarehouseProduct: 151, name: "Canguro Silver Alluminio 52" },
        { idWarehouseProduct: 152, name: "Canguro Bianco Ghiaccio 53" },
        { idWarehouseProduct: 153, name: "Canguro Blu Competizione 81" },
        { idWarehouseProduct: 154, name: "Canguro Blu Metallizzato 55" },
        { idWarehouseProduct: 155, name: "Canguro Blu Scozia 54" },
        { idWarehouseProduct: 156, name: "Canguro Blu Riflettente 77" },
        { idWarehouseProduct: 157, name: "Canguro Azzurro Jerez 64" },
        { idWarehouseProduct: 158, name: "Canguro Azzurro Leopard 76" },
        { idWarehouseProduct: 159, name: "Canguro Verde Naturale 66" },
        { idWarehouseProduct: 160, name: "Canguro Verde Fluorescente 58" },
        { idWarehouseProduct: 161, name: "Canguro verde petrolio 82" },
        { idWarehouseProduct: 162, name: "Canguro Ottanio 83" },
        { idWarehouseProduct: 163, name: "Canguro Rosso Misano 70" },
        { idWarehouseProduct: 164, name: "Canguro Rosso Factory 19" },
        { idWarehouseProduct: 165, name: "Canguro Rosso Fluorescente 60" },
        { idWarehouseProduct: 166, name: "Canguro Rosso Scuderia 80" },
        { idWarehouseProduct: 167, name: "Canguro Fucsia 85" },
        { idWarehouseProduct: 168, name: "Canguro Bordeaux 84" },
        { idWarehouseProduct: 169, name: "Canguro Giallo Fluorescente 59" },
        { idWarehouseProduct: 170, name: "Canguro Giallo Corse 56" },
        { idWarehouseProduct: 171, name: "Canguro Arancione Fluorescente 61" },
        { idWarehouseProduct: 172, name: "Canguro Arancione Spielberg 86" },
        { idWarehouseProduct: 173, name: "Canguro Azzurro Gresini" },
        { idWarehouseProduct: 174, name: "Canguro Blu Sasaki" },
        { idWarehouseProduct: 175, name: "Racing Nero Asfalto 50" },
        { idWarehouseProduct: 176, name: "Racing Grigio Grafite 51" },
        { idWarehouseProduct: 177, name: "Racing Silver Alluminio 52" },
        { idWarehouseProduct: 178, name: "Racing Bianco Ghiaccio 53" },
        { idWarehouseProduct: 179, name: "Racing Blu Competizione 81" },
        { idWarehouseProduct: 180, name: "Racing Blu Metallizzato 55" },
        { idWarehouseProduct: 181, name: "Racing Blu Scozia 54" },
        { idWarehouseProduct: 182, name: "Racing Blu Riflettente 77" },
        { idWarehouseProduct: 183, name: "Racing Azzurro Jerez 64" },
        { idWarehouseProduct: 184, name: "Racing Azzurro Leopard 76" },
        { idWarehouseProduct: 185, name: "Racing Verde Naturale 66" },
        { idWarehouseProduct: 186, name: "Racing Verde Fluorescente 58" },
        { idWarehouseProduct: 187, name: "Racing verde petrolio 82" },
        { idWarehouseProduct: 188, name: "Racing Ottanio 83" },
        { idWarehouseProduct: 189, name: "Racing Rosso Misano 70" },
        { idWarehouseProduct: 190, name: "Racing Rosso Factory 19" },
        { idWarehouseProduct: 191, name: "Racing Rosso Fluorescente 60" },
        { idWarehouseProduct: 192, name: "Racing Rosso Scuderia 80" },
        { idWarehouseProduct: 193, name: "Racing Fucsia 85" },
        { idWarehouseProduct: 194, name: "Racing Bordeaux 84" },
        { idWarehouseProduct: 195, name: "Racing Giallo Fluorescente 59" },
        { idWarehouseProduct: 196, name: "Racing Giallo Corse 56" },
        { idWarehouseProduct: 197, name: "Racing Arancione Fluorescente 61" },
        { idWarehouseProduct: 198, name: "Racing Arancione Spielberg 86" },
        { idWarehouseProduct: 199, name: "Racing Azzurro Gresini" },
        { idWarehouseProduct: 200, name: "Racing Blu Sasaki" },
        { idWarehouseProduct: 201, name: "Crosta" },
        { idWarehouseProduct: 202, name: "Rinforzo Crostina" },
      ],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
    lastEditUser() {
      const user = this.$store.getters["users/get"](this.formData.lastUser);
      return user ? user.name + " " + user.surname : "";
    },
    lastEditDate() {
      return this.formData.lastUpdate
        ? this.$moment.unix(this.formData.lastUpdate).format("DD/MM/YYYY HH:mm")
        : "";
    },
    graphicImages() {
      if (this.useMainProjectImages) {
        if (
          this.mainProjectDocs &&
          this.mainProjectDocs.graphics &&
          this.mainProjectDocs.graphics.images
        ) {
          return this.mainProjectDocs.graphics.images;
        }
        return [];
      } else {
        return this.docs.graphics.images;
      }
    },
    color1: {
      get() {
        if (!this.graphicsData.color1 || this.graphicsData.color1 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color1)) {
          return this.findProductIdByLeatherName(this.graphicsData.color1);
        } else {
          return this.graphicsData.color1;
        }
      },
      set(newVal) {
        this.graphicsData.color1 = newVal;
      },
    },
    color2: {
      get() {
        if (!this.graphicsData.color2 || this.graphicsData.color2 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color2)) {
          return this.findProductIdByLeatherName(this.graphicsData.color2);
        } else {
          return this.graphicsData.color2;
        }
      },
      set(newVal) {
        this.graphicsData.color2 = newVal;
      },
    },
    color3: {
      get() {
        if (!this.graphicsData.color3 || this.graphicsData.color3 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color3)) {
          return this.findProductIdByLeatherName(this.graphicsData.color3);
        } else {
          return this.graphicsData.color3;
        }
      },
      set(newVal) {
        this.graphicsData.color3 = newVal;
      },
    },
    color4: {
      get() {
        if (!this.graphicsData.color4 || this.graphicsData.color4 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color4)) {
          return this.findProductIdByLeatherName(this.graphicsData.color4);
        } else {
          return this.graphicsData.color4;
        }
      },
      set(newVal) {
        this.graphicsData.color4 = newVal;
      },
    },
    color5: {
      get() {
        if (!this.graphicsData.color5 || this.graphicsData.color5 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color5)) {
          return this.findProductIdByLeatherName(this.graphicsData.color5);
        } else {
          return this.graphicsData.color5;
        }
      },
      set(newVal) {
        this.graphicsData.color5 = newVal;
      },
    },
    color6: {
      get() {
        if (!this.graphicsData.color6 || this.graphicsData.color6 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color6)) {
          return this.findProductIdByLeatherName(this.graphicsData.color6);
        } else {
          return this.graphicsData.color6;
        }
      },
      set(newVal) {
        this.graphicsData.color6 = newVal;
      },
    },
    color7: {
      get() {
        if (!this.graphicsData.color7 || this.graphicsData.color7 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color7)) {
          return this.findProductIdByLeatherName(this.graphicsData.color7);
        } else {
          return this.graphicsData.color7;
        }
      },
      set(newVal) {
        this.graphicsData.color7 = newVal;
      },
    },
    color8: {
      get() {
        if (!this.graphicsData.color8 || this.graphicsData.color8 == "") {
          return "";
        } else if (isNaN(this.graphicsData.color8)) {
          return this.findProductIdByLeatherName(this.graphicsData.color8);
        } else {
          return this.graphicsData.color8;
        }
      },
      set(newVal) {
        this.graphicsData.color8 = newVal;
      },
    },
    color1qnt: {
      get() {
        if (!this.graphicsData.color1qnt || this.graphicsData.color1qnt == "") {
          return "";
        } else {
          return this.graphicsData.color1qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color1qnt = newVal;
      },
    },
    color2qnt: {
      get() {
        if (!this.graphicsData.color2qnt || this.graphicsData.color2qnt == "") {
          return "";
        } else {
          return this.graphicsData.color2qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color2qnt = newVal;
      },
    },
    color3qnt: {
      get() {
        if (!this.graphicsData.color3qnt || this.graphicsData.color3qnt == "") {
          return "";
        } else {
          return this.graphicsData.color3qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color3qnt = newVal;
      },
    },
    color4qnt: {
      get() {
        if (!this.graphicsData.color4qnt || this.graphicsData.color4qnt == "") {
          return "";
        } else {
          return this.graphicsData.color4qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color4qnt = newVal;
      },
    },
    color5qnt: {
      get() {
        if (!this.graphicsData.color5qnt || this.graphicsData.color5qnt == "") {
          return "";
        } else {
          return this.graphicsData.color5qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color5qnt = newVal;
      },
    },
    color6qnt: {
      get() {
        if (!this.graphicsData.color6qnt || this.graphicsData.color6qnt == "") {
          return "";
        } else {
          return this.graphicsData.color6qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color6qnt = newVal;
      },
    },
    color7qnt: {
      get() {
        if (!this.graphicsData.color7qnt || this.graphicsData.color7qnt == "") {
          return "";
        } else {
          return this.graphicsData.color7qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color7qnt = newVal;
      },
    },
    color8qnt: {
      get() {
        if (!this.graphicsData.color8qnt || this.graphicsData.color8qnt == "") {
          return "";
        } else {
          return this.graphicsData.color8qnt;
        }
      },
      set(newVal) {
        this.graphicsData.color8qnt = newVal;
      },
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.graphics = this.graphicsData;
      docs.cutting = this.formData;
      docs.cutting.lastUser = this.user.idWorldUser;
      docs.cutting.lastUpdate = this.$moment().unix();
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    showPic(img) {
      this.picToShow = img;
      this.showDrawer = false;
      this.tabToShow = "pic";
    },
    closePic() {
      this.tabToShow = "default";
      this.picToShow = null;
    },
    selectColorList() {
      let colorList = this.colorList;
      return colorList;
    },
    findProductIdByLeatherName(leatherName) {
      for (let i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].name === leatherName) {
          return this.colorList[i].idWarehouseProduct;
        }
      }
      // Ritorna null se il nome non è stato trovato
      return leatherName;
    },
    getColorName(productId) {
      for (let i = 0; i < this.colorList.length; i++) {
        if (this.colorList[i].idWarehouseProduct === productId) {
          return this.colorList[i].name;
        }
      }
      // Ritorna null se il nome non è stato trovato
      return productId;
    },
  },
  created() {
    this.formData = { ...this.docs.cutting };
    this.graphicsData = { ...this.docs.graphics };
    if (this.formData.notes && Array.isArray(this.formData.notes)) {
      if (this.formData.notes.length > 0) {
        this.formData.notes = this.formData.notes[
          this.formData.notes.length - 1
        ].note;
      } else {
        this.formData.notes = "";
      }
    }
  },
  components: {
    PictureViewer,
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
.input-elem {
  width: 100%;
  max-width: 200px;
}
.input-qnt-elem {
  max-width: 50px;
}
.stamp {
  height: 450px !important;
}
.pic-viewer {
  height: calc(90vh - 91px);
  width: 100%;
  justify-content: center;
  position: relative;
}
.close-pic {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 20px;
  height: 20px;
  z-index: 10;
  cursor: pointer;
}
</style>
